"use strict";

var _taggedTemplateLiteral = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _toConsumableArray = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/toConsumableArray");

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  background: transparent;\n  border-radius: ", ";\n  padding: ", ";\n  display: flex;\n  align-items: center;\n  transition: background 0.1s linear, color 0.1s linear;\n  color: ", ";\n  &:hover {\n    background: ", ";\n    color: ", ";\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  margin-right: auto;\n  padding-right: ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  margin-left: auto;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  padding: ", ";\n  padding-left: ", ";\n  display: flex;\n  align-items: center;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  height: 1px;\n  background: ", ";\n  width: calc(100% - ", ");\n  margin-left: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BackgroundHoverListItem = exports.ListItemLeft = exports.ListItemRight = exports.ListItem = exports.ListSeparator = exports.List = void 0;

var web_1 = require("@thesisedu/web");

var react_1 = __importDefault(require("react"));

function List(_ref) {
  var children = _ref.children,
      separated = _ref.separated,
      large = _ref.large;

  if (separated) {
    var childrenArr = react_1.default.Children.toArray(children);
    return react_1.default.createElement(react_1.default.Fragment, null, childrenArr.reduce(function (acc, child, index) {
      if (index === childrenArr.length - 1) {
        return [].concat(_toConsumableArray(acc), [child]);
      } else {
        return [].concat(_toConsumableArray(acc), [child, react_1.default.createElement(exports.ListSeparator, {
          large: large,
          key: "sep-".concat(index)
        })]);
      }
    }, []));
  } else return react_1.default.createElement(react_1.default.Fragment, null, children);
}

exports.List = List;
exports.ListSeparator = web_1.styled.div(_templateObject(), function (props) {
  return props.theme['@border-color-split'];
}, function (props) {
  return props.theme[props.large ? '@size-l' : '@size-s'];
}, function (props) {
  return props.theme[props.large ? '@size-l' : '@size-s'];
});

function ListItem(_ref2) {
  var children = _ref2.children,
      rightContent = _ref2.rightContent,
      large = _ref2.large;
  return react_1.default.createElement(ListItemContainer, {
    large: large
  }, children, rightContent ? react_1.default.createElement(exports.ListItemRight, {
    children: rightContent
  }) : null);
}

exports.ListItem = ListItem;
var ListItemContainer = web_1.styled.div(_templateObject2(), function (props) {
  return props.theme[props.large ? '@size-s' : '@size-xs'];
}, function (props) {
  return props.theme[props.large ? '@size-l' : '@size-s'];
});
exports.ListItemRight = web_1.styled.div(_templateObject3());
exports.ListItemLeft = web_1.styled.div(_templateObject4(), function (props) {
  return props.theme['@size-s'];
});

function BackgroundHoverListItem(_ref3) {
  var children = _ref3.children,
      rightContent = _ref3.rightContent;
  return react_1.default.createElement(BackgroundHoverListItemContainer, null, children, rightContent ? react_1.default.createElement(exports.ListItemRight, {
    children: rightContent
  }) : null);
}

exports.BackgroundHoverListItem = BackgroundHoverListItem;
var BackgroundHoverListItemContainer = web_1.styled.div(_templateObject5(), function (props) {
  return props.theme['@border-radius-base'];
}, function (props) {
  return props.theme['@size-xs'];
}, function (props) {
  return props.theme['@text-color'];
}, function (props) {
  return props.theme['@gray-1'];
}, function (props) {
  return props.theme['@gray-7'];
});